import { ADD_SIHARA } from "redux/constants/admin/masterdata/constants";

const initialState = {
    loading: false,
    loadingAction: false,
    isModalAction: false,
    submitSuccess: false,

    dataSimpananSihara: {
        data: [],
        count: 0,
    },

    queryKey: "",
    selectedIds: [],

    cache: {},
    loadingByKey: {},
};

const siharaReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SIHARA.LOADING_DATA_SIHARA_SUCCESS:
            return {
                ...state,
                loading: action.load,
            };

        case ADD_SIHARA.LOADING_ACTION_SIHARA:
            return {
                ...state,
                loadingAction: action.load,
            };

        case ADD_SIHARA.IS_MODAL_ACTION_SIHARA:
            return {
                ...state,
                isModalAction: action.load,
            };

        case ADD_SIHARA.GET_DATA_SIHARA_SUCCESS:
            return {
                ...state,
                dataSimpananSihara: action.data,
            };

        case ADD_SIHARA.SIHARA_SUCCESS:
            return {
                ...state,
                submitSuccess: true,
            };

        case ADD_SIHARA.SIHARA_RESET:
            return {
                ...state,
                submitSuccess: false,
            };

        case ADD_SIHARA.SET_QUERY_KEY:
            return {
                ...state,
                queryKey: action.key,
            };

        case ADD_SIHARA.ADD_SELECTED_IDS:
            return {
                ...state,
                selectedIds: Array.from(
                    new Set([...state.selectedIds, ...action.ids])
                ),
            };

        case ADD_SIHARA.REMOVE_SELECTED_IDS:
            return {
                ...state,
                selectedIds: state.selectedIds.filter(
                    (id) => !action.ids.includes(id)
                ),
            };

        case ADD_SIHARA.CLEAR_SELECTED_IDS:
            return {
                ...state,
                selectedIds: [],
            };

        case ADD_SIHARA.SET_CACHE_ENTRY:
            return {
                ...state,
                cache: {
                    ...state.cache,
                    [action.key]: action.data,
                },
            };

        case ADD_SIHARA.SET_LOADING_FOR_KEY:
            return {
                ...state,
                loadingByKey: {
                    ...state.loadingByKey,
                    [action.key]: action.loading,
                },
            };

        case ADD_SIHARA.UPDATE_CACHE_ITEMS: {
            const updatedCache = { ...state.cache };

            Object.keys(updatedCache).forEach((key) => {
                const entry = updatedCache[key];
                if (!entry?.data) return;

                updatedCache[key] = {
                    ...entry,
                    data: entry.data.map((item) =>
                        action.changesById[item.id]
                            ? { ...item, ...action.changesById[item.id] }
                            : item
                    ),
                };
            });

            return {
                ...state,
                cache: updatedCache,
            };
        }

        default:
            return state;
    }
};

export default siharaReducer;
